import http from '@/service/http'
import findIndex from 'lodash/findIndex'


const save = async (context, obj) => {
  console.log('CALLED')
  const { verb, transacoesCompraVenda } = obj
 
  const response = await http[verb]('/transacoesCompraVenda', transacoesCompraVenda)

  if (response !== null) {

    transacoesCompraVenda.id = response.data.data.id
    update(context, { ...transacoesCompraVenda })
    return Promise.resolve()
  }
}

const saveFile = async (context, obj) => {
  const { verb, comprovante } = obj
  const response = await http[verb]('/transacoesCompraVenda/comprovante', comprovante)
  console.log('saveFile finish')
  if (response !== null) {
    if (response.status !== 500) {
      comprovante.id = response.data.data.id
      comprovante.path = response.data.data.path
      comprovante.nome = response.data.data.nomeArquivo
      update(context, { ...comprovante })
    }
    return Promise.resolve()
  }
}

const saveFileAtendimento = async (context, obj) => {
  const { domain, comprovante } = obj
  const response = await http.post(`/transacoesIntegradas/comprovante?domain=${domain}`, comprovante)
  if (response !== null) {
    if (response.status !== 500) {
      comprovante.id = response.data.data.id
      comprovante.path = response.data.data.path
      comprovante.nome = response.data.data.nomeArquivo
      update(context, { ...comprovante })
    }
    return Promise.resolve()
  }
}

const saveStatus = async (context, obj) => {
  const { verb, transacoesCompraVenda } = obj
  const response = await http[verb]('/transacoesCompraVenda/atualizaStatus', transacoesCompraVenda)

  if (response !== null) {
    transacoesCompraVenda.id = response.data.data.id
    update(context, { ...transacoesCompraVenda })
    return Promise.resolve()
  }
}

const saveAtendimentoStatus = async (context, obj) => {
  const { transacoesCompraVenda, domain } = obj
  const response = await http.put(`/transacoesIntegradas/atualizaStatus?domain=${domain}`, transacoesCompraVenda)

  if (response !== null) {
    transacoesCompraVenda.id = response.data.data.id
    update(context, { ...transacoesCompraVenda })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/transacoesCompraVenda/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}
const updateByPicPayId = async ({commit}, id) => {
  if (id !== null && id !== undefined) {
    const response = await http.get(`/transacoesCompraVenda/picpay/${id}`)
    if (response !== null) {
      const transacaoPicPay = response.data.data
      if (transacaoPicPay != null) {
        commit('SET_LIST', [transacaoPicPay])
      }
    }
  }
}
const fetchMaisAntigas = async ({commit}, obj) => {
  const { tipo, pagina, quantidadePorPagina, storageItens } = obj

  let url = `/transacoesCompraVenda?tipo=${tipo}&pagina=${pagina}&por_pagina=${quantidadePorPagina}`
  const response = await http.get(`${url}`)

  if (response !== null) {
 
    const paginas = response.data.data.quantidadeDePaginas
    commit('SET_QUANTIDADE_PAGINAS', paginas)

    const transacoesCompraVenda = response.data.data.transacoes
    var transacoesCompraVendaNew = []

    if(storageItens) {

      for (let index = 0; index < storageItens.length; index++) {

        const id = storageItens[index];
        const exist = transacoesCompraVenda.filter(function (transacao) { return transacao.id == id }).length;

        if(exist == 0){

          const response = await http.get(`/transacoesCompraVenda/${id}`)
        
          if (response !== null) {
  
            transacoesCompraVendaNew.push(response.data.data[0])
  
          }       
        }
        
      }

      if(transacoesCompraVendaNew.length > 0){

        var itens = transacoesCompraVenda.concat(transacoesCompraVendaNew)
        commit('SET_LIST', itens)
      }
      else{
        commit('SET_LIST', transacoesCompraVenda)
      }


    }
    else{
      commit('SET_LIST', transacoesCompraVenda)
    }


 
   
  }
}

 

const fetchMaisAntigasFilter = async ({commit}, obj) => {
  const { tipo, pagina, quantidadePorPagina, filter, campo } = obj
  let filtroCampo = ''
  if (campo.includes('DATA')) {
    filtroCampo = 'DATA'
  } else if (campo.includes('CÓDIGO')) {
    filtroCampo = 'CODIGO'
  } else {
    filtroCampo = campo
  }
  let filterValue = filter
  if (campo.includes('CPF') || campo.includes('DATA')) {
    filterValue = filterValue.replace('/[^0-9.]/g', '')
  } else {
    filterValue = filterValue.replace('/^[a-zA-Z0-9 ]*$/', '')
  }
  if (!campo.includes('DATA') || (campo.includes('DATA') && filter !== undefined && filter.length === 10)) {
    let url = `/transacoesCompraVenda?tipo=${tipo}&pagina=${pagina}&por_pagina=${quantidadePorPagina}&filtro=${filtroCampo}&filtro_valor=${filterValue}`
    const response = await http.get(`${url}`)
    if (response !== null) {
      const paginas = response.data.data.quantidadeDePaginas
      commit('SET_QUANTIDADE_PAGINAS', paginas)
      const transacoesCompraVenda = response.data.data.transacoes
      commit('SET_LIST', transacoesCompraVenda)
    }
  } else {
    console.log('consulta não realizar')
  }
}

const fetchAllDataClientBigBoost = async (context, cpf) => {
  const response = await http.get(`/clientes-big-boost/get-all-data-client-big-boost/${cpf}`)
  if (response !== null) {
    // console.log('fetchAllDataClientBigBoost')
    if (response.data.data !== undefined && response.data.data.length > 0) {
      return Promise.resolve(response.data.data[0])
    }
  }
}

const fetchAllDataClientBigBoostAtendimento = async (context, domain, cpf) => {
  const response = await http.get(`/transacoesIntegradas/get-all-data-client-big-boost/${cpf}?domain=${domain}`)
  if (response !== null) {
    if (response.data.data !== undefined && response.data.data.length > 0) {
      return Promise.resolve(response.data.data[0])
    }
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/transacoesCompraVenda')
  if (response !== null && response.data !== undefined) {
    // console.log(JSON.stringify(response.data))
    const transacoesCompraVenda = response.data
    commit('SET_LIST', transacoesCompraVenda)
  }
}

const updateCountMessages = ({ commit, state }, obj) => {
  const { countMessages } = obj
  const index = findIndex(state.listCountMessagesChat, { id: countMessages.id })
  const payload = { countMessages, index }

  commit('SET_COUNT_MESSAGENS', payload)
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { transacoesCompraVenda: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/transacoesCompraVenda/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

const fetchOneList = async ({commit}, id) => {
  // console.log('consultar transacao')
  const response = await http.get(`/transacoesCompraVenda/listar/${id}`)
  if (response !== null) {
    const transacoesCompraVenda = response.data
    commit('SET_LIST', transacoesCompraVenda)
  }
}

const quantidadeTransacoes = async ({commit}) => {
  let url = '/transacoesCompraVenda/quantidadeTransacoes'
  console.log('call url:' + url)
  const response = await http.get(`${url}`)
  if (response !== null) {
    const paginas = response.data.data
    commit('SET_QUANTIDADE_TRANSACOES_ABERTAS', paginas)
  }
}

const removerComprovante = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    console.log('removerComprovante.id: ' + obj)
    const response = await http.delete(`/transacoesCompraVenda/removerComprovante/${obj}`)
    if (response.data.data !== 'undefined') {
      const message = response.data.data
      resolve(message)
    }
  })
}

export default {
  fetch,
  fetchOne,
  updateByPicPayId,
  fetchMaisAntigas,
  fetchAllDataClientBigBoost,
  fetchAllDataClientBigBoostAtendimento,
  save,
  updateCountMessages,
  saveAtendimentoStatus,
  saveStatus,
  update,
  remove,
  fetchOneList,
  fetchMaisAntigasFilter,
  quantidadeTransacoes,
  saveFile,
  saveFileAtendimento,
  removerComprovante
}



// WEBPACK FOOTER //
// ./src/features/admin/transacoesCompraVenda/store/actions.js